import { useCallback, type FC, type PropsWithChildren } from 'react'

import IntegrationCardBase, * as IntegrationCard from '@segment/matcha/recipes/IntegrationCard'

import { trackCatalogCardClick } from '@segment/tracking/scripts'

import type { Hit } from '@segment/api/algolia/client'

import type { FetchedCatalogIntegration } from '@segment/api/routes/catalog/queries'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const EMPTY_QUERY_MESSAGE = `No search term specified`

interface IntegrationCardTemplateProps {
  integration: Hit<FetchedCatalogIntegration>
  isInCategoryGrid?: Boolean
  query?: string
}
const IntegrationCardTemplate: FC<PropsWithChildren<IntegrationCardTemplateProps>> = ({
  integration,
  isInCategoryGrid,
  query,
}) => {
  const pageConfig = usePageConfig()

  const onClickHandler = useCallback(async () => {
    await trackCatalogCardClick({
      searchTerm: query ?? EMPTY_QUERY_MESSAGE,
      catalogItem: integration?.slug?.replace(/\//g, ``),
    })
  }, [integration, query])

  return (
    <IntegrationCardBase
      href={getAbsoluteUrl(`/catalog/integrations/${integration.type}${integration.slug}`, pageConfig)}
      key={integration.objectID}
      onClick={onClickHandler}
    >
      {integration.beta && <IntegrationCard.Badge>Beta</IntegrationCard.Badge>}
      <IntegrationCard.Row centered={true}>
        <IntegrationCard.LogoWrapper>
          <IntegrationCard.Logo
            width={integration.logo?.width}
            height={integration.logo?.height}
            src={integration.logo?.src ?? ``}
            alt="integration logo"
          />
        </IntegrationCard.LogoWrapper>
      </IntegrationCard.Row>
      <IntegrationCard.Row>
        <IntegrationCard.Name>{integration.name}</IntegrationCard.Name>
        {!isInCategoryGrid && (
          <IntegrationCard.Description>{integration.categories?.[0]?.category?.name}</IntegrationCard.Description>
        )}
      </IntegrationCard.Row>
    </IntegrationCardBase>
  )
}

export default IntegrationCardTemplate
